define('modules/editor/views/controls/page_margin',['require','exports','module','base/itemview','ldsh!../../templates/controls/page_margin'],function(require, exports, module) {
  "use strict";
  var BaseView = require("base/itemview");
  var PageMarginView = BaseView.extend({
    template: require("ldsh!../../templates/controls/page_margin"),
    className: "margin-control v-side",

    events: {
      "mousedown .handle": "onHandleDrag"
    },

    initialize: function(options) {
      this.side = options.side || "left";
    },

    helpers: function() {
      return {
        handleClass: this.side === "left" ? "cl" : "cr"
      };
    },

    onRender: function() {
      //add the left-side or right-side
      this.$el.css("zIndex", 900);
      this.$el.addClass(this.side + "-side");
    },

    onHandleDrag: function(e) {
      if(e.which !== 1) { return; }
      e.preventDefault();
      //save initial absolute pos
      this.startOffset = this.$el.offset();
      $(document).on("mousemove", _.bind(this.onHandleMove, this));
      $(document).on("mouseup", _.bind(this.onHandleRelease, this));
    },

    onHandleMove: function(e) {
      var deltaX = e.pageX - this.startOffset.left,
        currentAreaWidth = this.$el.parents('.lpg-page').width();

      if (this.side === "right") {
        this.$el.css("right", -deltaX);
        this.refreshOffsetHelpers('cr', currentAreaWidth + deltaX);
      }
      else {
        this.$el.css("left", deltaX);
        this.refreshOffsetHelpers('cl', currentAreaWidth - deltaX);
      }
    },

    refreshOffsetHelpers: function (positionKey, positionValue) {
      $('.handle__' + positionKey + '__position').show().text(positionValue + 'px');
    },

    onHandleRelease: function(e) {
      var deltaX = e.pageX - this.startOffset.left;
      $(document).off('mousemove mouseup');
      $('.handle__position').hide();

      this.trigger("margin:resize", {
        delta: (this.side === "right") ? deltaX : -deltaX
      });

      //remove inline styles so the bars
      //reposition themselves
      this.$el.css(this.side, 0);
    }

  });

  module.exports = PageMarginView;
});

